/* ================================
 *  JAVASCRIPT FUNCTIONS
 * ===============================*/

/**
 *  Check if the dom element is just barely visible.
 *  @example if (isAnyPartOfElementInViewport($cta)) {
 *    doThat();
 *  }
 *  @param {[string]} el [DOM element]
 */
function isAnyPartOfElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    var windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
    var horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
}

/**
 *  Check if the dom element is completely visible.
 *  @example if (isElementInViewport($cta)) {
 *    doThat();
 *  }
 *  @param  {[string]} el [DOM element]
 */
function isElementInViewport(el) {
    var rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

/**
 *  Launch the function provided as callback only once based on the delay.
 *  (For scroll, resize, mouseMove... events).
 *  @example window.addEventListener('scroll', throttle(function(e){
 *      // Le code ici ne pourra être exécuté que toutes les 50ms
 *  }, 50))
 *  @param {function} callback 
 *  @param {Number} delay 
 */
function throttle(callback, delay) {
    var last, timer;
    var delay = delay != undefined ? delay : 50;

    return function () {
        var context = this;
        var now = +new Date();
        var args = arguments;
        if (last && now < last + delay) {
            // le délai n'est pas écoulé on reset le timer
            clearTimeout(timer);
            timer = setTimeout(function () {
                last = now;
                callback.apply(context, args);
            }, delay);
        } else {
            last = now;
            callback.apply(context, args);
        }
    };
}

/**
 *  Delay the launch of the function provided as callback and reset the delay everytime the function is called.
 *  (For keyup event, like for a autocomplete feature).
 *  @example search.addEventListener('keyup', debounce(function(e){
 *      // Le code ici sera exécuté au bout de 350 ms si la fonction n'est pas rappelé
 *  }, 350))
 *  @param {function} callback 
 *  @param {Number} delay 
 */
function debounce(callback, delay) {
    var timer;
    var delay = delay != undefined ? delay : 350;

    return function () {
        var args = arguments;
        var context = this;

        clearTimeout(timer);
        timer = setTimeout(function () {
            callback.apply(context, args);
        }, delay)
    }
}

/* ================================
 *  JQUERY FUNCTIONS
 * ===============================*/

/** Make $ a global variable of jQuery */
if (self.jQuery != undefined)
    $ = jQuery;

(function ($, root, undefined) {

    // Add functions here

    /**
     *  Check if the dom element has multiple class
     *  @example $('monElement').hasAnyClass('class1 class2');
     */
    $.fn.hasAnyClass = function () {
        for (var i = 0; i < arguments.length; i++) {
            if (this.hasClass(arguments[i])) {
                return true;
            }
        }
        return false;
    }

    /**
     * jQuery function to prevent default anchor event and take the href * and the title to make a share popup
     * @param  {[object]} e           [Mouse event]
     * @param  {[integer]} intWidth   [Popup width defalut 500]
     * @param  {[integer]} intHeight  [Popup height defalut 400]
     * @param  {[boolean]} blnResize  [Is popup resizeabel default true]
     */
    $.fn.customerPopup = function (e, intWidth, intHeight, blnResize) {

        // Prevent default anchor event
        e.preventDefault();

        // Set values for window
        var intWidth = intWidth || '500',
            intHeight = intHeight || '400',
            strResize = (blnResize ? 'yes' : 'no');

        // Set title and open popup with focus on it
        var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
            strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,
            objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
    }

    // Social media share on ".share" class
    $(document).ready(function ($) {
        $('.share').on("click", function (e) {
            $(this).customerPopup(e);
        });
    });

})(jQuery, this);